export default function evaluate (inputTokens) {
  if (inputTokens.length > 3) {
    const firstThreeTokens = inputTokens.slice(0, 3);
    const result = evaluate(firstThreeTokens);
    const nextTokens = [result, ...inputTokens.slice(3)];
    return evaluate(nextTokens);
  }

  if (inputTokens.length === 2) {
    return evaluate([inputTokens[0]]);
  }

  try {
    return eval(inputTokens.join('')) || 0;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(inputTokens);
    // eslint-disable-next-line no-console
    console.error(error);
    return 0;
  }
}
